import React, { Component } from 'react';
import Calendar from 'react-feather/dist/icons/calendar.js';
import InputGroup, { Addons } from './InputGroup.jsx';
import { default as ReactDateTime } from 'react-datetime';
import { format, parseISO } from 'date-fns';

import './Datetime.scss';

let it = 0;

const isoRegex = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

export class Datetime extends Component {
  static defaultProps = {
    inputProps: {},
    className: null
  };

  constructor(props) {
    super(props);

    this.state = {
      value: this.getDatetimeFormatted(props.input && props.input.value ? props.input.value : undefined)
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.input && this.props.input.value !== prevProps.input.value) {
      this.setState({
        value: this.getDatetimeFormatted(this.props.input.value)
      });
    }
  }

  getFormat() {
    const formats = {
      date: (this.props.dateFormat === undefined) || this.props.dateFormat || '',
      time: (this.props.timeFormat === undefined) || this.props.timeFormat || ''
    };

    let format = '';
    if (formats.date === true) {
      format = 'P';
    } else {
      format = formats.date;
    }
    
    if (formats.time === true) {
      format += (format.date ? ' ' : '') + 'p';
    } else {
      format += formats.time;
    }

    return format;
  }

  getDatetimeFormatted(utcDate) {
    if (utcDate && utcDate.match(isoRegex)) {
      return format(parseISO(utcDate), this.getFormat());
    }
    return utcDate;
  }

  render() {
    const { input, meta, inputProps, className, ...rest } = this.props;
    const newInputProps = {
      ...inputProps,
      className
    };

    return (
      <ReactDateTime 
        value={this.state.value}
        className="datetime-form-group"
        closeOnSelect={true}
        onChange={this.onChange} 
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        renderInput={this.renderInput}
        inputProps={newInputProps}
        utc={true}
        {...rest} />
    );
  }

  onBlur = () => {
    this.props.input.onBlur();
  };

  onFocus = () => {
    this.props.input.onFocus();
  };

  onChange = (inputDate) => {
    let date = null;
    if (typeof inputDate === 'object' && inputDate._isAMomentObject) {
      inputDate = inputDate.toDate();
    }

    if (inputDate instanceof Date) {
      date = format(inputDate, 'yyyy-MM-dd HH:mm:ss');
    } else if (inputDate.match(isoRegex)) {
      date = format(parseISO(inputDate), 'yyyy-MM-dd HH:mm:ss');
    } else {
      date = inputDate;
    }

    this.props.input.onChange(date);
    return inputDate;
  };

  renderInput = (props, openCalendar) => {
    const { input, meta, ...field } = this.props;
    const name = 'dt' + (input.name || it++);
    const id = `${meta.form}_${name}`.replace('.', '_');

    return (
      <div className="form-group">
        {field.label && <label htmlFor={id}>{field.label}</label>}
        <InputGroup
          className="form-control"
          addons={Addons.right}
          id={id}
          input={{ ...props, name }}
          placeholder={field.placeholder}
          meta={meta}
          inputAddon={<span className="input-group-append"><button type="button" onClick={openCalendar} className="btn btn-primary"><Calendar /></button></span>}
        />
      </div>
    );
  }
}

export default Datetime;